import { Command, HttpMethod } from "~/extensions/api";
import dayjs from "dayjs";
import { store } from "~/pages/taikyo/store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
export class InsertTaikyo extends Command {
    constructor() {
        super(HttpMethod.Post, "taikyo/insert");
    }
    taikyoYmd = null;
    taikyoRiyuKb = -1;
    taikyoRiyu = "";
    renrakuPostCode = "";
    renrakuAdr1 = "";
    renrakuAdr2 = "";
    renrakuAdr3 = "";
    taikyoKaiyakuStatus = 1;
    renrakuTel = "";
    renrakuEmail = "";
    kaiyakuYmd = null;
    sonotaKeiyaku = "";
    movingServices = null;
    privacyConsent = null;
    nyukyokeiyakuNo = -1;
    orgNyukyokeiyakuNo = -1;
    taikyoNo = -1;
    static create(taikyo) {
        let command = new InsertTaikyo();
        command.nyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.nyukyokeiyakuNo;
        command.orgNyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo;
        command.taikyoYmd = dayjs(taikyo.taikyoYmd ?? "").toDate();
        command.taikyoRiyuKb = taikyo.taikyoRiyuKb;
        command.taikyoRiyu = taikyo.taikyoRiyu;
        command.renrakuPostCode = taikyo.postCode;
        command.renrakuAdr1 = taikyo.adr1;
        command.renrakuAdr2 = taikyo.adr2;
        command.renrakuAdr3 = taikyo.adr3;
        command.renrakuTel = taikyo.tel;
        command.renrakuEmail = taikyo.email;
        command.kaiyakuYmd = taikyo.kaiyakuYmd;
        command.sonotaKeiyaku = taikyo.sonotaKeiyaku;
        command.movingServices = taikyo.movingServices;
        command.privacyConsent = store.privacyConsent;
        return command;
    }
}
